'use client';

import React from 'react';

import { BrowseProductsList } from '../../../../components/BrowseProductsList';
import { PageHeader } from '../../../components/PageHeader';

import styles from './styles.module.css';

import { Filters } from '@/components/Filters';
import { QuizResultsHeader } from '@/components/QuizResultsHeader';
import { BrowseByTypes } from '@/modules/activityTracker/constants';
import { useBrowseTracking } from '@/modules/browse/useBrowseTracking';
import { type CMSExplorePage as CMSExplorePageType } from '@/modules/cms/types';
import { isQuizResultPageSlug } from '@/modules/quiz/utils';
import { useSearchId } from '@/modules/search/useSearchId';

type CMSExplorePageProps = {
  contentfulData: CMSExplorePageType;
};

export function CMSExplorePage({ contentfulData }: CMSExplorePageProps) {
  const {
    heading,
    description,
    cta,
    headerModule,
    featuredShops,
    searchQuery,
    slug,
    brands,
  } = contentfulData;
  const searchId = useSearchId();

  const isQuizResultPage = isQuizResultPageSlug(slug);

  const { handleProductClick } = useBrowseTracking({
    searchId,
    browseType: BrowseByTypes.EXPLORE_RESULTS,
    label: heading,
    query: searchQuery,
    slug,
  });

  return (
    <>
      {isQuizResultPage ? (
        <QuizResultsHeader
          slug={slug}
          description={description}
          bubbleNavItems={headerModule?.itemsCollection.items}
          popularBrandSlugs={brands?.brandsCollection?.items.map(
            (item) => item.brand
          )}
        />
      ) : (
        <PageHeader
          title={heading}
          description={description}
          bubbleNavItems={headerModule?.itemsCollection.items}
          featuredShops={featuredShops}
          popularBrandSlugs={brands?.brandsCollection?.items.map(
            (item) => item.brand
          )}
        >
          {cta && (
            <div className={styles.ctaWrapper}>
              <a href={cta.url} target="_blank" rel="noreferrer">
                {cta.copy}
              </a>
            </div>
          )}
        </PageHeader>
      )}
      <Filters showActiveFilters={false} />
      <BrowseProductsList
        handleProductClick={handleProductClick}
        query={searchQuery}
      />
    </>
  );
}
